import { useQuery } from "react-query";
import { getCtas } from "../services/school/cta/getCtas";
import { PagedRequestType } from "../types/PagedResults";
import { Key_ctas } from "../utils/constants";

export const useGetCtasQuery = (data: PagedRequestType, options: any = null) =>
  useQuery(
    [Key_ctas, JSON.stringify(data)],
    () => getCtas(data),
    options ? { ...options } : {}
  );